export const colors = [
  "#EF858C",
  "#F9C270",
  "#FFF67F",
  "#C1DB81",
  "#61C1BE",
  "#54C3F1",
  "#796BAF",
];
